<template>
  <div>
    <div v-if="team_dropdown_should_be_shown" class=" d-inline-block ml-10">
      <label>Team: </label>
      <dropdown-list
        :preselected_id="selected_team_id"
        :object_category="getTeamCategory"
        @objectIsSelected="teamDropdownSelected($event)"
        :isHeaderDropdown="true"
      />
    </div>

    <div v-if="team_dropdown_should_be_shown" class=" d-inline-block ml-5">
      <label>Type: </label>
      <dropdown-list
        :isListView="true"
        :team_id_filter="filter_selected_team_id"
        :object_category="getTypeCategory"
        :preselected_id="selected_type_id"
        :disabled="false"
        @objectIsSelected="typeIsSelected($event)"
        :isHeaderDropdown="true"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  getTeamCategory,
  getTypeCategory,
  isHomeUrl,
  isObjectViewUrl,
  isTeamsUrl
} from "../../../utils/RoutesUtils";
import DropdownList from "./DropdownList.vue";
export default {
  components: { DropdownList },
  name: "FiltersDropdowns",

  data() {
    return {
      selected_team_id: null,
      selected_type_id: null,
    };
  },

  mounted() {
    this.selected_team_id = this.filter_selected_team_id;
  },

  computed: {
    ...mapGetters(["filter_selected_team_id"]),
    ...mapGetters(["filter_selected_type_id"]),

    team_dropdown_should_be_shown() {
      const current_url = this.$route.path;
      return (
        !isTeamsUrl(current_url) &&
        !isHomeUrl(current_url) &&
        !isObjectViewUrl(current_url)
      );
    },

    getTeamCategory() {
      return getTeamCategory();
    },

    getTypeCategory() {
      return getTypeCategory();
    }
  },

  methods: {
    ...mapActions(["updateSelectedTeamId"]),
    ...mapActions(["updateSelectedTypeId"]),
    ...mapActions(["updateSelectedGroupId"]),

    teamDropdownSelected(object) {
      this.selected_team_id = null != object ? object.id : null;
      this.updateSelectedTeamId(this.selected_team_id);
      this.updateSelectedTypeId(null);
      this.updateSelectedGroupId(null);
    },

    typeIsSelected: function(object) {
      if (null != object) {
        this.selected_type_id = object.id;
        this.updateSelectedTypeId(this.selected_type_id);
      } else {
        this.selected_type_id = null;
        this.updateSelectedTypeId(null);
      }
    }
  }
};
</script>
